const regx = {}
//  验证手机号
regx.testUser = /^(?![0-9]+$)[0-9a-z]{4,32}$/
regx.testPhone =/^1[3456789]\d{9}$/
regx.testEmail=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
export default regx